import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaWhatsapp,
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaTimes,
  FaBars,
} from "react-icons/fa";
import StaffLineLogo from "./StaffLineLogo";
import "./Navbar.css";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  /* Close menu on route change */
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  /* Add background on scroll */
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* Lock body scroll when mobile menu is open */
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";
  }, [menuOpen]);

  return (
    <header className="staffline-navbar-wrapper">
      {/* ===== TOP INFO BAR ===== */}
      <div className="staffline-top-bar">
        <div className="staffline-top-bar-left">
          <span>
            <FaMapMarkerAlt /> Accra, Ghana
          </span>
          <span>
            <FaPhoneAlt /> +233 53 103 0191
          </span>
          <span>
            <FaEnvelope /> stafflinetransportgh@gmail.com
          </span>
        </div>

        <div className="staffline-top-bar-right">
          <a
            href="https://wa.me/233531030191"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp"
          >
            <FaWhatsapp />
          </a>
          <a
            href="https://www.facebook.com/StaffLineTransport"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Facebook"
          >
            <FaFacebookF />
          </a>
          
          <a
            href="https://www.linkedin.com/company/staffline-transport-ltd/home/?viewAsMember=true"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn />
          </a>
        </div>
      </div>

      {/* ===== MAIN NAVBAR ===== */}
      <nav
        className={`staffline-main-navbar ${
          scrolled ? "staffline-navbar-scrolled" : ""
        }`}
      >
        {/* ===== LEFT: LOGO ===== */}
        <div className="staffline-navbar-left">
          <NavLink to="/" className="staffline-navbar-logo">
            <StaffLineLogo />
          </NavLink>
        </div>

        {/* ===== RIGHT: NAV LINKS + CTA ===== */}
        <div
          className={`staffline-navbar-right ${
            menuOpen ? "staffline-navbar-right-open" : ""
          }`}
        >
          <NavLink
            to="/"
            end
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            Home
          </NavLink>

          <NavLink
            to="/about-us"
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            About Us
          </NavLink>

          <NavLink
            to="/routes"
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            Routes
          </NavLink>

          <NavLink
            to="/subscription"
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            Subscription
          </NavLink>

          <NavLink
            to="/portal"
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            Portal
          </NavLink>

          <NavLink
            to="/contact-us"
            className={({ isActive }) =>
              isActive
                ? "staffline-nav-link staffline-nav-link-active"
                : "staffline-nav-link"
            }
          >
            Contact Us
          </NavLink>

          {/* CTA BUTTON */}
          <NavLink to="/subscription" className="staffline-navbar-cta">
            Subscribe Now
          </NavLink>

          {/* MOBILE CLOSE */}
          <button
            className="staffline-mobile-close"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <FaTimes />
          </button>
        </div>

        {/* ===== HAMBURGER ===== */}
        <button
          className="staffline-hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle navigation"
        >
          <FaBars />
        </button>
      </nav>
    </header>
  );
};

export default Navbar;